import React, {Component} from 'react';
import styled from 'styled-components'
import {Col, Container, media, Row} from 'styled-bootstrap-grid';
import PropTypes from "prop-types";

import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";
import "../../css/alice-carousel.css";
import {connect} from "react-redux";
import {FaPlay} from 'react-icons/fa';
import {FaPause} from 'react-icons/fa';
import FsLightbox from 'fslightbox-react';
import VideoCover from 'react-video-cover';


const Wrapper = styled.div`

  padding-bottom: ${(props) => props.noPadding ? "0px" : "calc(var(--pad) - 18px)"};
  width: 100%;
  height: 100%;
  overflow: hidden;

`;


const ContainerS = styled(Container)`
  width: 100%;
  height: 100%;

`;

const VideoOverlay = styled.div`
position: absolute;
  width: 100%;
  height: 100%;

`;

const CenterIconWrap = styled.div`
width: 135px;
height: 135px;
border-radius: 75px;
background-color: ${(props) => props.playPauseBackground && (!props.isPlaying || props.mouseMoving) ? 'rgba(23,23,23, 0.03)' : 'rgba(23,23,23, 0.00)'};

  position: absolute;
  left:0; right:0;
  top:0; bottom:0;
  margin:auto;
  transition: all 1s;
        
  max-width:100%;
  max-height:100%;

  -webkit-transition-property: opacity;
  transition-property: opacity;
       
`;

const PlayIconWrap = styled.div`
width: 100%;
height: 100%;
margin-left: -6px;
position: absolute;
  transition: all 0.2s;
  -webkit-transition-duration: 0.2s;
  transition-duration: 0.2s;
  -webkit-transition-property:  opacity;
  transition-property:  opacity;

  opacity: ${(props) => !props.isPlaying  ? '0.85' : '0'};

  &:hover {
    opacity: ${(props) => !props.isPlaying  ? '1' : '0'};
  }

`;

const PlayIcon = styled(FaPlay)`
transition: all 0.2s;
margin-top: 30px;
margin-left: 35px;
  position: relative;
  cursor: pointer;
  display: inline-block;
  color: white;
  
  mix-blend-mode: difference;
  
  width: 75px;
height: 75px;
  
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  -webkit-transition-duration: 0.2s;
  transition-duration: 0.2s;
  -webkit-transition-property: transform, opacity;
  transition-property: transform, opacity;
  
  &:hover {
    -webkit-transform: scale(1.15);
    transform: scale(1.15);
  }
  
`;

const PauseIconWrap = styled.div`
margin-left: -6px;
width: 100%;
height: 100%;
position: absolute;
  transition: all 0.2s;
  -webkit-transition-duration: 0.2s;
  transition-duration: 0.2s;
  -webkit-transition-property:  opacity;
  transition-property:  opacity;

  opacity: ${(props) => props.isPlaying && props.mouseMoving ? '0.85' : '0'};

  &:hover {
    opacity: ${(props) => props.isPlaying && props.mouseMoving ? '1' : '0'};
  }

`;

const PauseIcon = styled(FaPause)`
transition: all 0.2s;
margin-top: 30px;
margin-left: 30px;
  position: relative;
  cursor: pointer;
  display: inline-block;
  color: white;
  mix-blend-mode: difference;
  
  width: 75px;
height: 75px;
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  -webkit-transition-duration: 0.2s;
  transition-duration: 0.2s;
  -webkit-transition-property: transform, opacity;
  transition-property: transform, opacity;
  
  &:hover {
    -webkit-transform: scale(1.15);
    transform: scale(1.15);
  }
  
`;

const VideoCoverS = styled(VideoCover)`
  width: 100%;
  height: 100%;
  overflow: hidden;
    background-color: #1B1B1B;
`;


class VideoBox extends Component {

    constructor(props) {
        super(props);

        this.state = {
            muted: false,
            isPlaying: false,
            mouseMoving: false,
            mouseOnPauseButton: false,
        };
    }


    // in case we want to add a lightbox to the video, basically allowing fullscreen. Maybe do it without the lightbox?
    toggleLightBox(index) {
        this.setState({lightBoxOpened: !this.state.lightBoxOpened, lightBoxSlide: index})
    }

    mouseMoved(e) {

        if (this.state.isPlaying)
        {
            this.setState({mouseMoving: true});

            let timeout;
            (() => {
                clearTimeout(timeout);
                timeout = setTimeout(() => this.setState(
                    (!this.state.isPlaying) ?
                        {mouseMoving: false}
                        :
                        this.state.mouseOnPauseButton ? {mouseMoving: true} : {mouseMoving: false}), 2000);
            })();
        }
        else
            this.setState({mouseMoving: false});
    }

    mouseEnterPause(e){
        this.setState({mouseOnPauseButton: true});
    }

    mouseExitPause(e){
        this.setState({mouseOnPauseButton: false});
    }

    playPauseClicked(){
        if (this.videoRef && this.videoRef.paused) {
            this.videoRef.play();
            this.setState({isPlaying: true});
        } else if (this.videoRef) {
            this.videoRef.pause();
            this.setState({isPlaying: false});
        }
    }

    render() {

        return (
            <Wrapper  noPadding={this.props.noPadding}>
                    <ContainerS onMouseMove={e => this.mouseMoved(e)}
                                onClick={() => this.playPauseClicked()}>
                        <Row>
                            <Col>
                                <VideoOverlay >
                                    <CenterIconWrap style={this.state.isPlaying ? {zIndex: '49'} : {zIndex: '51'}}
                                                    isPlaying={this.state.isPlaying} mouseMoving={this.state.mouseMoving}
                                                    playPauseBackground={this.props.playPauseBackground}>
                                        <PlayIconWrap isPlaying={this.state.isPlaying} mouseMoving={this.state.mouseMoving}>
                                            <PlayIcon />
                                        </PlayIconWrap>

                                    </CenterIconWrap>

                                    <CenterIconWrap style={this.state.isPlaying ? {zIndex: '51'} : {zIndex: '49'}}
                                                    isPlaying={this.state.isPlaying} mouseMoving={this.state.mouseMoving}
                                                    playPauseBackground={this.props.playPauseBackground}>

                                        <PauseIconWrap isPlaying={this.state.isPlaying} mouseMoving={this.state.mouseMoving}>
                                            <PauseIcon
                                                       onMouseOver={e => this.mouseEnterPause(e)}
                                                       onMouseOut={e => this.mouseExitPause(e)}
                                            />
                                        </PauseIconWrap>
                                    </CenterIconWrap>
                                </VideoOverlay>

                                <VideoCoverS videoOptions={{
                                    src: this.props.url,
                                    ref: videoRef => {
                                        this.videoRef = videoRef;
                                    },
                                }}>
                                </VideoCoverS>
                            </Col>

                        </Row>

                    </ContainerS>
            </Wrapper>
        )
    }
}


/*
                    <FsLightbox
                        toggler={this.state.lightBoxOpened}
                        slide={this.state.lightBoxSlide}
                        sources={this.props.slides.map((slide) => (slide.url))}
                    />
 */

VideoBox.propTypes = {
    url: PropTypes.string.isRequired,
    playPauseBackground: PropTypes.bool,
    noPadding: PropTypes.bool,
};

const mapStateToProps = (state) => ({
    device: state.device
});

export default VideoBox = connect(mapStateToProps)(VideoBox);